var MemberList = require('memberlist');


var MemberOpList = MemberList.extend({
    modeCategory: 'OP'
});


module.exports = MemberOpList;



//////////////////
// WEBPACK FOOTER
// ./app/src/collection/memberoplist.js
// module id = tR0s
// module chunks = 1